"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.new-section.prompt': 'Preséntame una nueva sección',
};
